import { get } from 'common/utils/request';
export var fetchProfileApi = function () {
    return get('/employees/self');
};
